module.exports = __webpack_public_path__ + "static/img/James-Tedesco.8ffa6f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/James-Tedesco.jpg
// module id = w4qB
// module chunks = 0